import { styled } from '@mui/material/styles'
import { themeSpacing } from 'eezy-components'

export const Container = styled('div')``

export const Header = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeSpacing(1.5)};
`

export const IconWrapper = styled('div')`
  svg {
    height: ${themeSpacing(5)};
    width: ${themeSpacing(5)};
  }
`

export const Content = styled('div')`
  margin-top: ${themeSpacing(2)};
`

export const ActionContainer = styled('div')`
  margin-top: ${themeSpacing(2)};
`
